import { GOV_SPONSOR, GOLD_SPONSORS } from "../lib/api";

export const Sponsors = ({ variant = "default" }) => {
  const compact = variant === "compact";
  return (
    <section
      data-testid="sponsors-section"
      className={compact ? "py-12 bg-rb-surface border-y border-rb-border" : "py-24 bg-rb-surface border-y border-rb-border"}
    >
      <div className="max-w-7xl mx-auto px-6">
        {!compact && (
          <div className="text-center mb-12">
            <div className="flex items-center justify-center gap-3 mb-4">
              <span className="h-[2px] w-10 bg-rb-red" />
              <span className="text-xs tracking-[0.4em] text-rb-red font-bold">
                PARTNERS & SPONSORS
              </span>
              <span className="h-[2px] w-10 bg-rb-red" />
            </div>
            <h2 className="font-heading text-3xl sm:text-4xl font-extrabold text-rb-ink">
              برعاية وشراكة
            </h2>
          </div>
        )}

        {/* Government sponsor */}
        <div className="mb-12">
          <div className="text-center mb-5">
            <span className="text-[10px] tracking-[0.3em] text-rb-textMuted uppercase">
              الراعي الحكومي الرسمي
            </span>
          </div>
          <div className="flex justify-center">
            <a
              href="#"
              data-testid="gov-sponsor"
              className="group bg-white border border-rb-border hover:border-rb-red transition-all p-4 flex flex-col items-center gap-3 min-w-[280px] shadow-sm"
            >
              <div className="bg-white p-4 w-full flex items-center justify-center border border-rb-border/60">
                <img
                  src={GOV_SPONSOR.logo}
                  alt={GOV_SPONSOR.name}
                  className="h-20 w-auto object-contain"
                />
              </div>
              <div className="text-center">
                <div className="font-heading text-base font-bold text-rb-ink">
                  {GOV_SPONSOR.name}
                </div>
                <div className="text-[10px] tracking-[0.25em] text-rb-textMuted uppercase mt-1">
                  {GOV_SPONSOR.nameEn}
                </div>
              </div>
            </a>
          </div>
        </div>

        {/* Golden sponsors */}
        <div>
          <div className="text-center mb-5">
            <span className="text-[10px] tracking-[0.3em] text-amber-600 uppercase font-bold">
              ⬥ رعاة النادي ⬥
            </span>
          </div>
          <div className="grid sm:grid-cols-3 gap-3">
            {GOLD_SPONSORS.map((s, i) => {
              const cardClasses =
                "group bg-white border border-rb-border hover:border-amber-500 transition-all p-3 flex flex-col items-center justify-center gap-3 min-h-[200px] shadow-sm";
              const inner = (
                <>
                  <div className="h-24 w-full bg-white flex items-center justify-center p-3">
                    <img
                      src={s.logo}
                      alt={s.name}
                      className="max-h-full max-w-full w-auto object-contain"
                    />
                  </div>
                  <div className="text-center mt-auto">
                    <div className="font-heading text-sm font-bold text-rb-ink">
                      {s.name}
                    </div>
                    <div className="text-[9px] tracking-[0.25em] text-rb-textMuted uppercase mt-1">
                      {s.nameEn}
                    </div>
                    {s.url && (
                      <div className="text-[10px] text-amber-600 mt-2 font-bold group-hover:underline">
                        {s.urlLabel || "زيارة"} ↗
                      </div>
                    )}
                  </div>
                </>
              );
              return s.url ? (
                <a
                  key={s.name}
                  href={s.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  data-testid={`gold-sponsor-${i}`}
                  className={cardClasses}
                >
                  {inner}
                </a>
              ) : (
                <div
                  key={s.name}
                  data-testid={`gold-sponsor-${i}`}
                  className={cardClasses}
                >
                  {inner}
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
};
